import React from 'react';
import Layout from '../components/Layout/Layout';

// Import social activity images (collages)
import karyakramA from '../images/KARYAKRAM A.jpg';
import karyakramB from '../images/KARYAKRAM B.jpg';
import sahityaA from '../images/SAHITYA SANMELAN A.jpg';
import sahityaB from '../images/SAHITYA SANMELAN B.jpg';
import vivahA from '../images/SAMUHIK VIVAH A.jpg';
import vivahB from '../images/SAMUHIK VIVAH B.jpg';
import vivahC from '../images/SAMUHIK VIVAH C.jpg';

const SocialActivityPage = () => {
  const images = [karyakramA, karyakramB, sahityaA, sahityaB, vivahA, vivahB, vivahC];

  return (
    <Layout>
      <div id="social-activity" className="page-container" style={{ backgroundColor: '#fff', minHeight: '100vh', padding: '40px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          
          <div style={{ 
            backgroundColor: '#333', 
            padding: '40px', 
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
          }}>
            <h2 style={{ color: '#90cdf4', borderBottom: '1px solid #555', paddingBottom: '20px', marginBottom: '30px', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'left' }}>
              Social Activity Gallery
            </h2>

            <div style={{ 
              borderLeft: '5px solid #3182ce', 
              paddingLeft: '20px'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
                gap: '20px'
              }}>
                {images.map((img, index) => (
                  <div key={index} style={{
                    borderRadius: '4px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                    backgroundColor: '#1a1a1a',
                    border: '1px solid #444'
                  }}>
                    <img 
                      src={img} 
                      alt={`Social Activity Collage ${index + 1}`} 
                      style={{ width: '100%', height: 'auto', display: 'block' }} 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SocialActivityPage;
